import { render, staticRenderFns } from "./ProductMainFields.vue?vue&type=template&id=d5e84ed4&scoped=true"
import script from "./ProductMainFields.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductMainFields.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductMainFields.vue?vue&type=style&index=0&id=d5e84ed4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e84ed4",
  null
  
)

export default component.exports